import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

export interface MQMessage {
    [key: string]: any
}

interface EVENTLISTENERS {
    [eventName: string]: { [id: string]: MQSubject<MQMessage>}
}

export class MQSubject<T> extends Subject<T> {
    protected static gIdx = 0;
    protected id: number;
    protected eventName: string;
    protected mq: MQService;

    constructor(mq: MQService, eventName: string) {
        super();
        MQSubject.gIdx = MQSubject.gIdx + 1;
        this.mq = mq;
        this.id = MQSubject.gIdx;
        this.eventName = eventName;
    }

    getId() {
        return this.id;
    }

    unsubscribe() {
        super.unsubscribe();
        this.mq.removeListener(this.eventName, this.id);
    }
}

@Injectable()
export class MQService {
    protected static noListenerMessages: { [key: number]: any[] } = {};
    protected static eventListeners: EVENTLISTENERS = {};

    listenOn(eventName: string): MQSubject<MQMessage> {
        if (!MQService.eventListeners.hasOwnProperty(eventName)) {
            MQService.eventListeners[eventName] = {};
        }

        const promise = new MQSubject<MQMessage>(this, eventName);
        MQService.eventListeners[eventName][promise.getId()] = promise;
        return promise;
    }

    notify(eventName: string, data: MQMessage) {
        if (MQService.eventListeners[eventName] === undefined) {
            console.warn(`notify to [${eventName}] but no listener`, data);
            return;
        }

        for (const key in MQService.eventListeners[eventName]) {
            if (MQService.eventListeners[eventName].hasOwnProperty(key)) {
                const promise =  MQService.eventListeners[eventName][key];
                if (promise) {
                    promise.next(data);
                }
            }
        }
    }

    removeListener(eventName: string, promisId: number) {
        if (MQService.eventListeners.hasOwnProperty(eventName)) {
            if (MQService.eventListeners[eventName].hasOwnProperty(promisId)) {
                delete MQService.eventListeners[eventName][promisId];
            }
        }
    }
}
